import { Component, EventEmitter, Inject, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/shared/services/apiService.service';
import { environment } from '../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
declare var $;

@Component({
  selector: 'app-test-drive-list',
  templateUrl: './test-drive-list.component.html',
  styleUrls: ['../profile/profile.component.scss']
})
export class TestDriveListComponent implements OnInit {

  page: any;
  environment1 = environment.s3bucket.url;
  sub: Subscription = new Subscription
  productLoaded: boolean = false

  status: any = "upcoming"
  totalItemsTD: any = 0;
  testDriveData: any = [];
  itemsPerPage: any = 10
  currentPage: any = 1;

  isMobile: boolean = false;
  maximumSize: any = 6;
  maximumsizeupcoming: any = 6
  constructor(private spinner: NgxSpinnerService,
    private toastrService: ToastrService, private apiService: ApiService, @Inject(PLATFORM_ID) private platformId: Object,) { }

  ngOnInit(): void {
    this.status = 'upcoming'
    // this.showBreadCrumbb('test drive');
    this.currentPage = 1
    if (isPlatformBrowser(this.platformId)) {
    $('.header').addClass('p-scroll');
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.isMobile = true;
      this.maximumSize = 6
      this.maximumsizeupcoming = 6
      // some code..
    } else {
      this.isMobile = false;
      this.maximumSize = 6
      this.maximumsizeupcoming = 6

    }
  }
    this.getTestDriveData({ "offset": 0, "size": 10, "status": ["Request Accepted", "PENDING", "C1 (Quote Tendered)"] });
  }

  @Output() goBack: EventEmitter<void> = new EventEmitter<void>();
  mobileBack() {
    this.goBack.emit();
  }

  pageChange(page: any) {
    this.currentPage = page;
    page = page - 1;
    let reqBody: any
    if (this.status == 'upcoming') {
      reqBody =
      {
        "offset": (page * 10),
        "size": (this.currentPage * 10),
        "status": ["Request Accepted", "PENDING", "C1 (Quote Tendered)"]
      };
    } else if (this.status == 'cancelled') {
      reqBody =
      {
        "offset": (page * 10),
        "size": (this.currentPage * 10),
        "status": ["cancelled"]
      };
    }

    this.getTestDriveData(reqBody);
  }
  getTestDriveData(reqBody: any) {
    this.spinner.show()
    // this.breadcrumbData = ['account', 'test drive'],
    this.totalItemsTD = 0
    this.sub.add(this.apiService.getBooking(reqBody).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.spinner.hide();
          this.testDriveData = response.data
          this.totalItemsTD = response.range_info.total_count
          if (isPlatformBrowser(this.platformId)) {
            window.scroll(0, 0);
          }

        }
        else {
          this.testDriveData = []
          this.totalItemsTD = 0
          this.spinner.hide();
        }
      },
      error: () => {
        this.toastrService.warning("Something went wrong!")
        this.spinner.hide()
      },
      complete: () => {
      }
    }))
  }
  onClickStatus(status) {
    this.status = status;
    this.currentPage = 1;
    if (status == 'cancelled') {
      this.getTestDriveData({ "offset": 0, "size": 10, "status": ["cancelled"] });
    } else if (status == 'upcoming') {
      this.getTestDriveData({ "offset": 0, "size": 10, "status": ["Request Accepted", "PENDING", "C1 (Quote Tendered)"] });
    }
  }
  redirect(data) {
    let sublob = data.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (data.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : data.sub_lob.replace(/\s/g, "-")?.toLowerCase();
    let model = data.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
    var currentUrl = '/product-details/' + sublob + '/' + data.lob_seo + '/' + data.ppl_seo + '/' + model + '/' + data.id;
    return currentUrl;
  }

}


